import TableUsuarios from './TableUsuarios'

const Usuarios = () => {
  return (
    <div>
      <TableUsuarios />
    </div>
  )
}

export default Usuarios